import { Link } from "react-router-dom";
import { site } from "../../content/site";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-white/10 bg-[#711457]"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <p className="font-serif-display text-3xl sm:text-4xl text-white tracking-tight leading-tight max-w-md">
              {site.brand.tagline}
            </p>
            <p className="mt-6 text-sm font-sans-modern text-white/50 max-w-md leading-relaxed">
              Lakewood, NJ 08701
            </p>
            <div className="mt-4 flex flex-col text-sm font-sans-modern text-white/70">
              <a
                href={`mailto:${site.brand.email}`}
                data-testid="footer-email"
                className="hover:text-white transition-colors"
              >
                {site.brand.email}
              </a>
            </div>
          </div>

          <div className="md:col-span-7 grid grid-cols-2 gap-8">
            {site.footer.columns.map((col) => (
              <div key={col.heading}>
                <h4 className="text-[10px] font-sans-modern uppercase tracking-[0.25em] text-white/40 mb-5">
                  {col.heading}
                </h4>
                <ul className="space-y-3">
                  {col.links.map((l) => (
                    <li key={l.label}>
                      <Link
                        to={l.href}
                        data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                        className="text-base font-serif-display text-white/80 hover:text-white transition-colors"
                      >
                        {l.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-xs font-sans-modern text-white/40 tracking-wide">
            {site.footer.legal}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
